import Methods from "../methods";

const getItemMateriales = (context, payload) => {
  const url = `reportes/itemMateriales/${payload.idClient}?${payload.param}`;
  return Methods.doGet(context, url, null);
};


const dowloadItemMateriales = (context, payload) => {
  const url = `reportes/dowloadItemMateriales/${payload.idClient}?${payload.param}`;
  if(payload.email){
    return Methods.doPost(context, url, null);
  }else{
    return Methods.doPostDonwload(context, url, {extExport:'xlsx'},'Reporte_Item_Materiales');
  }

};

const dowloadItemMaterialesById = (context, payload) => {
  const url = `reportes/dowloadItemMaterialesById/${payload.idClient}/${payload.idMaterial}`;
    return Methods.doPostDonwload(context, url, {extExport:'xlsx'},`Reporte_Item_Materiales_${payload.code}`);
};

const getOrderMateriales = (context, payload) => {
  const url = `reportes/orderMateriales/${payload.idClient}/${payload.idAddress}?${payload.param}`;
  return Methods.doGet(context, url, null);
};

const dowloandGetOrderMateriales = (context, payload) => {
  const url = `reportes/dowloandGetOrderMateriales/${payload.idClient}/${payload.idAddress}?${payload.param}`;
    return Methods.doPostDonwload(context, url, {extExport:'xlsx'},`Reporte_Estado_Materiales${payload.idAddress}`);
};


export default {
  getItemMateriales,
  dowloadItemMateriales,
  dowloadItemMaterialesById,
  getOrderMateriales,
  dowloandGetOrderMateriales

};



// WEBPACK FOOTER //
// ./src/api/modules/ReporteItemMateriales.js